import React from 'react'
import ProdTaskWastageRow from './ProdTaskWastageRow'
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import { UiAction, UiTitle, UiView, UiViewContent, UiViewHeading } from "../../../../../library/layout/Index";

const ProdTaskWastage = (props) => {
    const { formObject, viewData } = props;

    // console.log("task row", viewData);

    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormROValue formObject={formObject} rowKey="" action={{ paramName: "processName" }} />
                </UiTitle>
                
                <UiAction>
                    <div className="phAction">
                        <FormButton formObject={formObject} rowKey="" className="uiActionIconButton" starIcon={"adds"}
                            action={{ actionId: "new",  actionParam: {}, containerKey: "row" }}
                            text={<SarasTrans value="Add Wastage" />}
                        />
                    </div>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <ul className="uiListTable uiProductionTable uiRawDataView" style={{ backgroundColor: "#FFF", minWidth: "1290px" }}>
                    <li className="uiSearchHeading">
                        <ul>
                            <li className="uiColumnLeft uiColumn130"><SarasTrans value="Item Id" /></li>
                            <li className="uiColumnLeft uiColumn200"><SarasTrans value="Item Name" /></li>
                            <li className="uiColumnLeft uiColumn50"><SarasTrans value="Unit" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Issued" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Wasted" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Damaged" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Lost" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="% Waste" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="% Allow" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Allowed" /></li>
                            <li className="uiColumnRight uiColumnQty"><SarasTrans value="Diff" /></li>
                            <li className="uiColumnRight uiColumn70"><SarasTrans value="Unit Cost" /></li>
                            <li className="uiColumnRight uiColumn70"><SarasTrans value="Wastage Value" /></li>
                            <li className="uiColumnRight uiColumn70"><SarasTrans value="Deduction" /></li>
                            <li className="uiColumnLeft uiColumn70"><SarasTrans value="Remark" /></li>
                            <li className="uiColumnCenter uiColumn70"><SarasTrans value="Action" /></li>
                        </ul>
                    </li>
                    {
                        Object.values(viewData ? viewData : {}).map((row, index) => (
                            <li><ProdTaskWastageRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                        ))
                    }
                </ul>
            </UiViewContent>
        </UiView>
    )
}

export default withView(ProdTaskWastage, "prodTaskWaste", "");
